import * as React from "react";
import cn from "classnames";
import Styles from "../../Icon/Icon.module.scss";
import { IconProps, IconSizes } from "../icon-prop-types";

export const ErrorIcon = ({ fill = "orange", size = "xsmall" }: IconProps) => {
  const fillStyles = cn(Styles[fill], Styles.fill);
  return (
    <svg width={IconSizes[size]} height={IconSizes[size]} viewBox={"0 0 32 32"}>
      <path
        className={fillStyles}
        d="M15.9997333,30.6669333 C7.91306667,30.6669333 1.33306667,24.0869333 1.33306667,16.0002667 C1.33306667,7.9136 7.91306667,1.3336 15.9997333,1.3336 C24.0864,1.3336 30.6664,7.9136 30.6664,16.0002667 C30.6664,24.0869333 24.0864,30.6669333 15.9997333,30.6669333 M15.9997333,0.000266666667 C7.16373333,0.000266666667 -0.000266666667,7.16426667 -0.000266666667,16.0002667 C-0.000266666667,24.8362667 7.16373333,32.0002667 15.9997333,32.0002667 C24.8370667,32.0002667 31.9997333,24.8362667 31.9997333,16.0002667 C31.9997333,7.16426667 24.8370667,0.000266666667 15.9997333,0.000266666667 M16.9137333,18.7834667 L17.0537333,7.48613333 L14.9444,7.48613333 L15.0857333,18.7834667 L16.9137333,18.7834667 Z M15.9997333,21.842 C15.2504,21.842 14.6637333,22.4166667 14.6637333,23.178 C14.6637333,23.9273333 15.2504,24.514 15.9997333,24.514 C16.7610667,24.514 17.3357333,23.9273333 17.3357333,23.178 C17.3357333,22.4166667 16.7610667,21.842 15.9997333,21.842"
        fillRule="nonzero"
      />
    </svg>
  );
};
